module.exports = __webpack_public_path__ + "static/media/status.f0b5fc91.svg";